import { StrictMode } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import { ChakraProvider, extendTheme, type ThemeConfig } from '@chakra-ui/react';

import { StorageEngineFactory } from '@enterprise/core';
import { useEventListener } from '@enterprise/hooks';
import { hspColors } from '@enterprise/tailwind-config';

import { useAppConfiguration } from './hooks/app-configuration.hook';
import AppRouter from './router';

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const theme = extendTheme({
  colors: {
    hsp: {
      ...hspColors.solid,
      ...hspColors.alpha,
    },
  },
  config,
});

export default function App() {
  const { onErrorHandler } = useAppConfiguration();

  useEventListener({
    eventName: 'beforeunload',
    handler: () => {
      StorageEngineFactory.destroyAll();
    },
  });

  return (
    <StrictMode>
      <ChakraProvider
        resetCSS={false}
        theme={theme}>
        <ErrorBoundary
          fallback={<div>An error occurred</div>}
          onError={onErrorHandler}>
          <AppRouter />
        </ErrorBoundary>
      </ChakraProvider>
    </StrictMode>
  );
}
